'use client';

import { faPenToSquare } from '@fortawesome/pro-light-svg-icons';
import { ReactNode } from 'react';

import { CartItemFieldAction } from './cart-item.types';

import { IconButton } from '@/components/ui/icon-button/icon-button.component';
import { Typography } from '@/components/ui/typography/typography.component';

interface CartItemFieldProps {
  label: string;
  value: ReactNode;
  dataTestId: string;
  action?: CartItemFieldAction;
}

export function CartItemField({ label, value, dataTestId, action }: CartItemFieldProps) {
  return (
    <div className="flex items-start justify-between gap-2" data-testid={dataTestId}>
      <div className="flex flex-col text-base leading-6 text-gray-700">
        <Typography className="text-sm font-bold leading-5 text-gray-700">{label}</Typography>
        {value}
      </div>

      {action && (
        <IconButton
          size="lg"
          icon={faPenToSquare}
          label={action.label}
          onClick={action.onClick}
          iconClassName="text-green-500 group-active:text-green-600"
          data-testid={action.dataTestId}
        />
      )}
    </div>
  );
}
